import { supabase } from '../../../src/lib/supabase';
import { GrowattMetric, RateioUnidadeGeradora } from '../../../types';

const FUNCTION_POR_MARCA: Record<string, string> = {
  growatt: 'get-growatt-metrics',
  chint: 'get-chint-metrics',
  canadian: 'get-canadian-metrics',
  saj: 'get-saj-metrics',
};

export interface ProducaoRealResultado {
  producaoKwh: number;
  marca: string;
}

/**
 * Busca a produção real (telemetria) da UG, se ela tiver vínculo configurado
 * (telemetria_marca + telemetria_site_id). Usa as mesmas Edge Functions que
 * views/Geradoras/GeradorasView.tsx já consome — nenhuma alteração nelas.
 * prod_30d_kwh: pra Growatt é a soma real dos últimos 30 dias; pra Chint a
 * própria function já usa "mês atual" (pvEMonth) nesse campo — ainda mais
 * preciso pra representar o Excedente Alocável do mês corrente.
 */
export async function buscarProducaoRealUg(ug: RateioUnidadeGeradora): Promise<ProducaoRealResultado | null> {
  if (!ug.telemetria_marca || !ug.telemetria_site_id) return null;

  const functionName = FUNCTION_POR_MARCA[ug.telemetria_marca];
  if (!functionName) return null;

  const { data, error } = await supabase.functions.invoke(functionName);
  if (error) throw error;

  const metrics = (data?.data || []) as GrowattMetric[];
  const linha = metrics.find(m => m.site_id_api === ug.telemetria_site_id);
  if (!linha || linha.prod_30d_kwh == null) return null;

  return { producaoKwh: linha.prod_30d_kwh, marca: ug.telemetria_marca };
}
